// Delegation keeps controls working when Shopify re-renders or duplicates a section.
const storyOpeners = new WeakMap();
document.addEventListener('click', event => {
  const toggle = event.target.closest('.menu-toggle');
  if (toggle) {
    const nav = document.getElementById(toggle.getAttribute('aria-controls'));
    const opening = toggle.getAttribute('aria-expanded') !== 'true';
    toggle.setAttribute('aria-expanded', String(opening));
    nav?.classList.toggle('is-open', opening);
  }
  if (event.target.closest('.header nav a')) closeMenus();
  const opener = event.target.closest('[data-open-story]');
  if (opener) {
    const dialog = document.getElementById(opener.dataset.openStory);
    if (dialog) { storyOpeners.set(dialog, opener); dialog.showModal(); }
  }
  const close = event.target.closest('[data-close-dialog]');
  if (close) close.closest('dialog')?.close();
  if (event.target.matches('dialog')) {
    const box = event.target.getBoundingClientRect();
    if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) event.target.close();
  }
});
function closeMenus() {
  document.querySelectorAll('.menu-toggle').forEach(button => button.setAttribute('aria-expanded','false'));
  document.querySelectorAll('.header nav').forEach(nav => nav.classList.remove('is-open'));
}
document.addEventListener('keydown', event => { if (event.key === 'Escape') closeMenus(); });
document.addEventListener('close', event => {
  if (event.target.matches('dialog')) {
    event.target.querySelectorAll('video').forEach(video => video.pause());
    storyOpeners.get(event.target)?.focus();
  }
}, true);
document.addEventListener('change', event => {
  if (event.target.matches('[data-variant-picker]')) event.target.form.requestSubmit();
});
function showEditedBlock(event) {
  const block = event.target;
  if (block.matches('details')) block.open = true;
  const story = block.closest('.story');
  if (story) story.scrollIntoView({block:'nearest',inline:'center',behavior:'instant'});
}
document.addEventListener('shopify:block:select', showEditedBlock);
document.addEventListener('shopify:section:unload', event => {
  event.target.querySelectorAll('dialog[open]').forEach(dialog => dialog.close());
});
